import React, { useState, useEffect } from 'react';
import "../assets/style.css";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

function Slider({ imageData }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [slideImage, setSlideImage] = useState([]);

    // Log to verify what you're getting
    // console.log("Received imageData:", imageData);

    useEffect(() => {
        if (Array.isArray(imageData)) {
            setSlideImage(imageData);
        } else {
            console.warn("imageData is not an array:", imageData);
            setSlideImage([]);
        }
    }, [imageData]);

    useEffect(() => {
        const interval = setInterval(() => {
            goToNext();
        }, 3000);
        return () => clearInterval(interval);
    }, [currentSlide]);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const goToPrev = () => {
        setCurrentSlide((prev) => (prev === 0 ? slideImage.length - 1 : prev - 1));
    };

    const goToNext = () => {
        setCurrentSlide((prev) => (prev === slideImage.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className="slider-wrapper">
            <div className="simple-slider">
                <button className="slider-arrow left" onClick={goToPrev}>
                    <FaChevronLeft />
                </button>

                <div className="slides-container" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                    {slideImage.length > 0 ? (
                        slideImage.map((slide, index) => (
                            <div key={slide.id || index} className="slide">
                                <img src={slide.image} alt={slide.title} />
                            </div>
                        ))
                    ) : (
                        <p>No slides available</p>
                    )}
                </div>

                <button className="slider-arrow right" onClick={goToNext}>
                    <FaChevronRight />
                </button>
            </div>

            <div className="slider-dots">
                {slideImage.map((_, index) => (
                    <button
                        key={index}
                        className={`dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
}

export default Slider;
